import { FORT_AGENT_STATUS, type MyFortAgentItem } from "@/api/types";

/** 首页展示：优先已激活，否则取列表最后一台（最近购买） */
export function pickHomeDisplayAgent(
  agents: MyFortAgentItem[] | undefined
): MyFortAgentItem | null {
  const list = agents ?? [];
  if (list.length === 0) return null;
  const activated = list.find(a => a.status === FORT_AGENT_STATUS.ACTIVATED);
  if (activated) return activated;
  return list[list.length - 1];
}

export function isAgentActivated(agent: MyFortAgentItem): boolean {
  return agent.status === FORT_AGENT_STATUS.ACTIVATED;
}
